export const REQUEST_INSTRUCTION_DATA = "REQUEST_INSTRUCTION_DATA";
export const RECEIVE_INSTRUCTION_DATA = "RECEIVE_INSTRUCTION_DATA";
